export class LogSync {
    kind = "log";
    #apply;
    #key;
    #applied = new Set();
    constructor(options) {
        this.#apply = options.apply;
        this.#key = options.key ?? ((delta) => delta.id);
    }
    async applyDelta(delta, context) {
        void context;
        const key = this.#key(delta);
        if (this.#applied.has(key))
            return { applied: false };
        await this.#apply(delta.payload, delta);
        this.#applied.add(key);
        return { applied: true };
    }
}
//# sourceMappingURL=log-sync.js.map